( function( $ ) {
	'use strict';

	$( document ).ready( function() {

		$( '[data-toggle-view]' ).click( function() {
			const $ctrl = $( this );
			const $parent = $ctrl.closest( $ctrl.data('parent-selector') );
			// console.log($ctrl, $parent);

			if ( $ctrl.hasClass( 'collapsed' ) ) {
				$ctrl.html($ctrl.html().replace(/More/g, 'Less' ));
				$parent.find($ctrl.data('expanded-selector')).removeClass('d-none');
				$parent.find($ctrl.data('collapsed-selector')).addClass('d-none');
				$ctrl.removeClass('collapsed');
			} else {
				$ctrl.html($ctrl.html().replace(/Less/g, 'More' ));
				$parent.find($ctrl.data('expanded-selector')).addClass('d-none');
				$parent.find($ctrl.data('collapsed-selector')).removeClass('d-none');
				$ctrl.addClass('collapsed');
			}
		});

	});

} )( jQuery );
